export { default } from './Icon';
export { default as Icon } from './Icon';
export { iconMap } from './iconMap';
